// services/deviceAPI.js
const API_BASE_URL = "https://alcobrakeadmin.com/v3/us";
const APP_API_URL = "https://alcobrakeadmin.com/v3/app";

export const deviceAPI = {
  // ==================== DEVICE APIs ====================

    swapDevice: async ({ oldcbid, newcbid,fullclientid  }) => {
    const response = await fetch('https://alcobrakeadmin.com/v3/us/cadevices/swapdevice', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ oldcbid, newcbid,fullclientid  })
    });
    const text = await response.text();
    let data;
    try { data = JSON.parse(text); } catch { data = text; }
    if (!response.ok || data?.success === false || data?.status === false || data?.error) {
      throw new Error(data?.message || data?.error || (typeof data === 'string' && data) || 'Unable to swap device. Please try again.');
    }
    return data;
  },

  // Get all devices
  getAllDevices: async () => {
    const url = `${API_BASE_URL}/cadevices/getalldevices`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      return response.ok && data != null ? data : [];
    } catch (error) {
      console.error("Error fetching all devices:", error);
      throw error;
    }
  },

  // Get dealer devices
  getDealerDevices: async (dealerId) => {
    const url = `${API_BASE_URL}/cadevices/getdealerdevices?dealerName=${encodeURIComponent(dealerId)}`;
    console.log("Fetching dealer devices from:", url);
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      return response.ok && data != null ? data : [];
    } catch (error) {
      console.error("Error fetching dealer devices:", error);
      throw error;
    }
  },

  getProductionTracking: async (handset, controlid) => {
    const url = `${API_BASE_URL}/cadevices/getproductiontracking?&controlid=${encodeURIComponent(controlid)}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Unable to load production tracking.');
    }

    const data = await response.json();
    return Array.isArray(data) ? data : (data?.data || []);
  },

  getAllProductionTracking: async () => {
    const response = await fetch(`${API_BASE_URL}/cadevices/getproductiontracking`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to load production devices.');
    const data = await response.json();
    return Array.isArray(data) ? data : (data?.data || []);
  },

  insertProductionTracking: async (tracking) => {
    const response = await fetch(`${API_BASE_URL}/cadevices/insertproductiontracking`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(tracking)
    });

    if (!response.ok) {
      throw new Error('Unable to save production tracking.');
    }

    const responseText = await response.text();
    try {
      return JSON.parse(responseText);
    } catch {
      return responseText;
    }
  },

  // Create device
  createDevice: async (deviceData) => {
    const url = `${API_BASE_URL}/cadevices/adddevice`;
    console.log("Creating device at URL:", url);

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: deviceData,
      });

      const responseText = await response.text();
      console.log("Create device response:", response.status, responseText);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }

      return { success: true, message: data, data: data };
    } catch (error) {
      console.error("Error creating device:", error);
      throw error;
    }
  },

  // Edit device
  editDevice: async (sno, deviceData) => {
    const url = `${API_BASE_URL}/cadevices/editdevice/${sno}`;
    console.log("Editing device at URL:", url);

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: deviceData,
      });

      const responseText = await response.text();
      console.log("Edit device response:", response.status, responseText);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }

      return { success: true, message: data, data: data };
    } catch (error) {
      console.error("Error editing device:", error);
      throw error;
    }
  },

  // Delete device
  deleteDevice: async (devId) => {
    const url = `${API_BASE_URL}/cadevices/deletedevice/${devId}`;
    console.log("Deleting device at URL:", url);

    try {
      const response = await fetch(url, {
        method: 'GET',
      });

      const responseText = await response.text();
      console.log("Delete device response:", response.status, responseText);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }

      return { success: true, message: data };
    } catch (error) {
      console.error("Error deleting device:", error);
      throw error;
    }
  },

  getClientWithCbid: async (cbid) => {
    const url = `https://alcobrakeadmin.com/v3/v2/eeprom/getclientwithcbid?cbid=${encodeURIComponent(cbid)}`;
    console.log('[Device swap] Calling getclientwithcbid', url);
    if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
      console.warn('[Device swap] This HTTPS page is calling an HTTP API. The browser may block the request as mixed content. Check the Network tab.');
    }
    try {
      const response = await fetch(url);
      const data = await response.json();
      console.log('[Device swap] getclientwithcbid response', {
        status: response.status, cbid, clientid: data?.clientid, sno: data?.sno,
        error: data?.error, message: data?.message
      });
      if (String(data?.error || '').trim().toLowerCase() === 'no client found for this cbid' &&
          (response.ok || response.status === 404)) return null;
      if (!response.ok || data?.status === false || data?.error) {
        throw new Error(data?.message || data?.error || 'Unable to check the selected device client.');
      }
      return data;
    } catch (error) {
      console.error('[Device swap] getclientwithcbid request failed', { url, message: error.message });
      throw error;
    }
  },

  // Get device office/client info
  getDeviceOffice: async (sno) => {
    const url = `${API_BASE_URL}/fullclients/getuniquedevicefullclient?sno=${sno}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await response.json();
      if (response.ok && data && data[0]) return data[0].officeId;
      return null;
    } catch (error) {
      console.error("Error fetching device office:", error);
      return null;
    }
  },

  // Get serial number for new device
  getSerialNumber: async (state) => {
    const url = `${API_BASE_URL}/cadevices/getserialnumber?state=${state}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error getting serial number:", error);
      throw error;
    }
  },

  // Get device config
  getDeviceConfig: async (cbid) => {
    const url = `${API_BASE_URL}/cadevices/getdeviceconfig/${cbid}`;
    console.log("Fetching device config from:", url);
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      console.log("Device config response:", data);
      return data;
    } catch (error) {
      console.error("Error getting device config:", error);
      throw error;
    }
  },

  // ==================== OTA APIs ====================

  // SOTA - Sampler OTA (command 103)
  sendSotaCommand: async (cbid, devId) => {
    const url = `${APP_API_URL}/commands`;
    console.log("Sending SOTA command to:", url);
    console.log("Control Board ID (cbid):", cbid);
    console.log("Sampler ID (devId):", devId);

    try {
      // Send to control board FIRST
      const cmdData1 = { devId: cbid, command: "103" };
      const response1 = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cmdData1),
      });
      const result1 = await response1.text();
      console.log("SOTA Response - Control Board:", result1);

      // Send to sampler device
      const cmdData2 = { devId: devId, command: "103" };
      const response2 = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cmdData2),
      });
      const result2 = await response2.text();
      console.log("SOTA Response - Sampler:", result2);

      // Success if EITHER returns "OPERATION DONE"
      const success = (result1 === "OPERATION DONE" || result2 === "OPERATION DONE");
      return {
        success,
        message: success ? "Sampler OTA completed successfully" : "Sampler OTA failed"
      };
    } catch (error) {
      console.error("Error sending SOTA command:", error);
      throw error;
    }
  },

  // COTA - Control Board OTA (command 98)
  sendCotaCommand: async (cbid, devId) => {
    const url = `${APP_API_URL}/commands`;
    console.log("Sending COTA command to:", url);
    console.log("Control Board ID (cbid):", cbid);
    console.log("Sampler ID (devId):", devId);

    try {
      // Send to sampler device FIRST
      const cmdData1 = { devId: devId, command: "98" };
      const response1 = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cmdData1),
      });
      const result1 = await response1.text();
      console.log("COTA Response - Sampler:", result1);

      // Send to control board
      const cmdData2 = { devId: cbid, command: "98" };
      const response2 = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cmdData2),
      });
      const result2 = await response2.text();
      console.log("COTA Response - Control Board:", result2);

      // Success if EITHER returns "OPERATION DONE"
      const success = (result1 === "OPERATION DONE" || result2 === "OPERATION DONE");
      return {
        success,
        message: success ? "Control Board OTA completed successfully" : "Control Board OTA failed"
      };
    } catch (error) {
      console.error("Error sending COTA command:", error);
      throw error;
    }
  },

  // S3OTA - S3 OTA (command 107)
  sendS3OtaCommand: async (cbid, command = "107") => {
    const url = `${APP_API_URL}/commands`;
    console.log("Sending S3OTA command to:", url);
    console.log("Control Board ID (cbid):", cbid);
    console.log("Command:", command);

    try {
      // Only send to control board
      const cmdData = { devId: cbid, command: command, resp: "" };
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cmdData),
      });

      const result = await response.text();
      console.log("S3OTA Response:", result);

      const success = result === "OPERATION DONE";
      return {
        success,
        message: success ? "S3 OTA completed successfully" : "S3 OTA failed"
      };
    } catch (error) {
      console.error("Error sending S3OTA command:", error);
      throw error;
    }
  },

  // ==================== DEALER APIs ====================

  // Get all dealers
  getAllDealers: async () => {
    const url = `${API_BASE_URL}/cadealers/getalldealerss`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      const text = await response.text();
      const dealers = [];

      // Handle NDJSON streaming format
      if (text.includes('\n')) {
        const lines = text.split('\n');
        for (const line of lines) {
          if (line.trim()) {
            try {
              const dealer = JSON.parse(line);
              dealers.push(dealer);
            } catch (e) { }
          }
        }
      } else {
        try {
          const data = JSON.parse(text);
          if (Array.isArray(data)) {
            dealers.push(...data);
          } else if (data && data.data && Array.isArray(data.data)) {
            dealers.push(...data.data);
          }
        } catch (e) { }
      }

      console.log("Dealers parsed:", dealers.length);
      return dealers;
    } catch (error) {
      console.error("Error fetching dealers:", error);
      return [];
    }
  },

  // ==================== USER HELPER APIs ====================

  // Get user role from localStorage
  getUserRole: () => {
    try {
      const user = localStorage.getItem('admin_user');
      if (user) {
        const userData = JSON.parse(user);
        const role = userData.role || userData.accesslevel || userData.userRole;
        if (role === 'Admin' || role === 'superadmin' || role === 'admin') {
          return 'superadmin';
        }
        return role || 'user';
      }
    } catch (e) {
      console.error("Error parsing user data:", e);
    }
    return 'user';
  },

  // Get dealer ID from localStorage
  getDealerId: () => {
    try {
      const user = localStorage.getItem('admin_user');
      if (user) {
        const userData = JSON.parse(user);
        return userData.dealerId || userData.dealerid || userData.id;
      }
    } catch (e) {
      return null;
    }
    return null;
  },

  // Get dealer name from localStorage
  getDealerName: () => {
    try {
      const user = localStorage.getItem('admin_user');
      if (user) {
        const userData = JSON.parse(user);
        return userData.dealerName || userData.dealername || userData.name;
      }
    } catch (e) {
      return null;
    }
    return null;
  }
};
